import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import { Localidade } from "./localidade.model";
import { apiName } from "./data.service";

@Injectable()
export class LocalidadeApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Localidade, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Localidade, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"localidade","include":["tipoLocalidade",{"endereco":[{"cidade":"estado"},"tipoLogradouro"]}]};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    var filter: any = {"include":["tipoLocalidade",{"endereco":[{"cidade":"estado"},"tipoLogradouro"]}]};
    this._restService.onGetPostId(apiName, objectId, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/shared/localidade-api.service.ts
 **/